export default "__VITE_ASSET__PmqdFexv__"